import ExpenseGroupList from "../../Components/ExpenseGroupList";

export default function ExpenseGroups() {
  return (
    <div className="p-2">
      <ExpenseGroupList />
    </div>
  );
}
